import { ReduxWrapper, ReduxWrapperOutdatedInfo } from "../app.state";
import { UserProduct } from "src/app/models/user-products.model";

export class UserProductsState {
	theme!: ReduxWrapperOutdatedInfo<UserProduct[]>
	webpart!: ReduxWrapperOutdatedInfo<UserProduct[]>
	template!: ReduxWrapper<UserProduct[]>
	accessibility!: ReduxWrapper<UserProduct[]>
	sharedtemplate!: ReduxWrapper<UserProduct[]>
	sharedtheme!: ReduxWrapperOutdatedInfo<UserProduct[]>
}

export const productTypeDefaultValue: ReduxWrapper<UserProduct[]> = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	value:[]
};

export const webpartsDefaultValue: ReduxWrapperOutdatedInfo<UserProduct[]> = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	value:[],
	loadingInstalledInfo: false,
	loadedInstalledInfoOnce: false
}

export const themesDefaultValue: ReduxWrapperOutdatedInfo<UserProduct[]> = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	value:[],
	loadingInstalledInfo: false,
	loadedInstalledInfoOnce: false
}

export const userProductsInitialState: UserProductsState = {
	theme: themesDefaultValue,
	webpart: webpartsDefaultValue,
	template: productTypeDefaultValue,
	accessibility: productTypeDefaultValue,
	sharedtemplate: productTypeDefaultValue,
	sharedtheme: themesDefaultValue
};
